export function smoothKeypoints(currentKeypoints, previousKeypoints) {
  if (!previousKeypoints) {
    return currentKeypoints;
  }

  return currentKeypoints.map((kp, index) => {
    const prev = previousKeypoints[index];

    const currentScore = kp.score;
    const previousScore = prev.score || 0.01;

    const alpha = currentScore / (currentScore + previousScore);

    return {
      ...kp,
      x: alpha * kp.x + (1 - alpha) * prev.x,
      y: alpha * kp.y + (1 - alpha) * prev.y,
      score: Math.max(currentScore, previousScore),
    };
  });
}
